import type {EnvelopeNavigationResult} from '~/common/FabricInvitation/EventCreateDesign/components/EnvelopeDisplay/types/EnvelopeTypes';
import {useNavigator} from '~/common/fabric/CreateDesign/components/NavBottom/useNavigator';

export const useEnvelopeNavigation = (
  isMobile: boolean,
  redirectTo?: string,
  disableAutoOpenEditor: boolean = false
): EnvelopeNavigationResult => {
  const navigate = useNavigator({
    isMobile,
    disableAutoOpenEditor: disableAutoOpenEditor || redirectTo === 'CARD_DESIGN',
  });

  const handleNavigation = (): void => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  };

  return {handleNavigation};
};
